const NETWORK_REASONS = new Set([
  'SIGNAL_CLOSE',
  'STATE_MISMATCH',
  'JOIN_FAILURE',
  'CONNECTION_TIMEOUT',
  'MEDIA_FAILURE',
])

export const NETWORK_RESUME_DELAYS_MS = [2000, 6000, 15000] as const

const REASON_NAMES: Record<number, string> = {
  0: 'UNKNOWN_REASON',
  1: 'CLIENT_INITIATED',
  2: 'DUPLICATE_IDENTITY',
  3: 'SERVER_SHUTDOWN',
  4: 'PARTICIPANT_REMOVED',
  5: 'ROOM_DELETED',
  6: 'STATE_MISMATCH',
  7: 'JOIN_FAILURE',
  8: 'MIGRATION',
  9: 'SIGNAL_CLOSE',
  10: 'ROOM_CLOSED',
  11: 'USER_UNAVAILABLE',
  12: 'USER_REJECTED',
  13: 'SIP_TRUNK_FAILURE',
  14: 'CONNECTION_TIMEOUT',
  15: 'MEDIA_FAILURE',
  16: 'AGENT_ERROR',
}

export function disconnectReasonName(reason?: number): string | undefined {
  if (reason === undefined) return undefined
  return REASON_NAMES[reason]
}

export function isNetworkDisconnect(reason?: string): boolean {
  return Boolean(reason && NETWORK_REASONS.has(reason))
}

export function nextNetworkResumeDelay(attempt: number): number | null {
  return NETWORK_RESUME_DELAYS_MS[attempt] ?? null
}
